import { useQuery } from "react-query"
import ProofOfOwnershipService from "~services/ProofOfOwnershipService"

const useProofsOfOwnershipCounts = (userId?: string, enabled = true) => {
  return useQuery(
    ["proofs-of-ownership-counts", userId ?? ""],
    () => ProofOfOwnershipService.getProofsOfOwnershipCounts(userId),
    {
      enabled,
      staleTime: 2 * 60 * 1000,
      // Keep the filter pill counts in sync with the list on (re)mount.
      refetchOnMount: "always",
    },
  )
}

export default useProofsOfOwnershipCounts
